module.exports = __webpack_public_path__ + "static/media/plus-circle-inex.524a2475.svg";